<!-- Canvas Element used as the easel-js Stage where everything is drawn -->
<ng-container *ngIf="mapInModal == true">
  <canvas
    id="{{ getMapCanvasId() }}"
    (wheel)="onMouseWheel($event)"
    (mousedown)="onMouseDown($event)"
    (mousemove)="onMouseMove($event)"
    (mouseup)="onMouseUp($event)"
    (mouseleave)="onMouseLeave($event)"
    style="width: 100%; height: 100%; min-height: 250px;"
    (window:resize)="onWindowResize()"
  >
  </canvas>
</ng-container>
<ng-container *ngIf="mapInModal == false">
<canvas
	id="{{ getMapCanvasId() }}"
	(wheel)="onMouseWheel($event)"
	(mousedown)="onMouseDown($event)"
	(mousemove)="onMouseMove($event)"
	(mouseup)="onMouseUp($event)"
	(mouseleave)="onMouseLeave($event)"
	style="width: 100%; height: calc(100% - 85px); min-height: 250px;"
	(window:resize)="onWindowResize()"
	>
</canvas>
</ng-container>

<div class="scale-buttons">

  <ng-container *ngIf="displayMenu">
    <button class="btn btn-default btn-sm dropdown-toggle" type="button" data-toggle="dropdown">
      <i class="fa fa-cog" aria-hidden="true"></i>&nbsp;<i class="fa fa-caret-down" aria-hidden="true"></i>
    </button>
    <ul class="dropdown-menu" onclick="event.stopPropagation();">
      <li class="dropdown-header"><i class="fa fa-map-pin" aria-hidden="true"></i> Map Settings</li>
      <li><a><div class="checkbox checkbox-inline"><input type='checkbox' class="styled" [(ngModel)]="displayAssets"><label><i class="fa fa-star-o"></i> ASSETS</label></div></a></li>
      <li><a><div class="checkbox checkbox-inline"><input type='checkbox' class="styled" [(ngModel)]="displayPeople"><label><i class="fa fa-users"></i> PEOPLE</label></div></a></li>
      <li><a><div class="checkbox checkbox-inline"><input type='checkbox' class="styled" [(ngModel)]="displayPerimeters"><label><i class="fa fa-circle-thin"></i> PERIMETERS</label></div></a></li>
      <li><a><div class="checkbox checkbox-inline"><input type='checkbox' class="styled" [(ngModel)]="showBreadcrumbs"><label><i class="fa fa-ellipsis-h"></i> BREADCRUMBS</label></div></a></li>
      <li><a><div class="checkbox checkbox-inline"><input type='checkbox' class="styled" [(ngModel)]="displayZones"><label><i class="fa fa-dot-circle-o"></i> ZONES</label></div></a></li>
      <li><a><div class="checkbox checkbox-inline"><input type='checkbox' class="styled" [(ngModel)]="showZoneNames"><label><i class="fa fa-dot-circle-o"></i> ZONE NAMES</label></div></a></li>
      <li><a><div class="checkbox checkbox-inline"><input type='checkbox' class="styled" [(ngModel)]="displaySublocations"><label><i class="fa fa-map"></i> SUBLOCATIONS</label></div></a></li>
      <li><a><div class="checkbox checkbox-inline"><input type='checkbox' class="styled" [(ngModel)]="showSublocationNames"><label><i class="fa fa-map"></i> SUBLOCATION NAMES</label></div></a></li>
    </ul>
    &nbsp;
  </ng-container>
  <!-- Adjust Zoom and Restore Buttons -->
  <div class="btn-group">
    <button (click)="zoomIn()" type="button" class="btn btn-default btn-sm" style="cursor: pointer"><i class="fa fa-plus" aria-hidden="true"></i></button>
    <button (click)="zoomOut()" type="button" class="btn btn-default btn-sm" style="cursor: pointer"><i class="fa fa-minus" aria-hidden="true"></i></button>
    <button (click)="zoomToOriginal()" type="button" class="btn btn-default btn-sm" style="cursor: pointer"><i class="fa fa-crosshairs" aria-hidden="true"></i></button>
  </div>

</div>

<!-- Person Popups - Only add them for People that are currently drawn on the Stage -->
<ng-container *ngFor="let key of _Object.keys(mPeopleMap)">
	<ng-container *ngIf="mPeopleMap[key] != null && mPeopleMap[key].mIcon != null">
		<app-person-locate-popup
      [popupInModal]="mapInModal"
			[person]="mPeopleMap[key].mPerson"
			[dialogId]="getIdForPersonPopup(mPeopleMap[key])"
			[callHideEmitter]="mPeopleHideEmitterMap[mPeopleMap[key].mPerson.id]"
			>
		</app-person-locate-popup>
	</ng-container>
</ng-container>

<!-- Asset Popups - Only add them for Assets that are currently drawn on the Stage -->
<ng-container *ngFor="let key of _Object.keys(mAssetsMap)">
	<ng-container *ngIf="mAssetsMap[key] != null && mAssetsMap[key].mIcon != null">
		<app-asset-locate-popup
      [popupInModal]="mapInModal"
			[asset]="mAssetsMap[key].mObject"
			[dialogId]="getIdForObjectPopup(mAssetsMap[key])"
			[callHideEmitter]="mAssetHideEmitterMap[mAssetsMap[key].mObject.id]"
			>
		</app-asset-locate-popup>
	</ng-container>
</ng-container>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>